import React from 'react'

// Constants
import { SKETCH_WEBSITE } from '@sketch/constants'

// Styles
import { StyledLink } from '../SignInToLinkAccountPage.styles'

/**
 * Common links used in both Verification Code and Recovery Code UI
 */
export const HelpNote: React.FC = () => {
  return (
    <>
      Lost your recovery codes?{' '}
      <StyledLink
        external
        variant="primary"
        isUnderlined
        href={`${SKETCH_WEBSITE}/support/contact/`}
      >
        Contact us
      </StyledLink>
      <br />
    </>
  )
}

export default HelpNote
